<template>
    <div class="error-msg-wrap">
        <div v-if="isLoaded" class="form-wrapper slide-up" style="width:500px">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <h3>Who Can View</h3>
            <div v-if="isCompany">
                Everyone in the company can see and update the <b>{{ teamLabel(team) }}</b> scoreboard.
            </div>
            <template v-else>
            <div style="margin-bottom:15px">
                Anyone whose employee record is on the <b>{{ teamLabel(team) }}</b> team can see and update this scoreboard. Teams are set on each employee's record.
            </div>
            <div class="my-checklists-label">Standard users ({{ publicUsers.length }})</div>
            <div v-if="publicUsers.length" class="who-can-view-list" style="margin-bottom:20px">
                <div v-for="u in publicUsers" :key="u.ID">{{ u.FirstName }} {{ u.LastName }}</div>
            </div>
            <div class="my-checklists-label">Admins & editors ({{ users.length }})</div>
            <div v-if="users.length" class="who-can-view-list" style="margin-bottom:20px">
                <div v-for="u in users" :key="u.UserID">{{ u.FirstName }} {{ u.LastName }}</div>
            </div>
            <div class="my-checklists-label">Team Hub Admins ({{ teamHubAdmins.length }})</div>
            <div v-if="teamHubAdmins.length" class="who-can-view-list">
                <div v-for="u in teamHubAdmins" :key="u.UserID">{{ u.FirstName }} {{ u.LastName }}</div>
            </div>
            </template>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';
import { COMPANY_TEAM } from '../scoreboard';

// Scoreboard access is by team (scoreboard.ts accessibleTeams): active public users and accounts
// whose employee record is on the team, plus Team Hub Admins, who see every team. The Company
// group is open to everyone, so there's no list to show.
export default defineComponent({
    name: 'ScoreboardWhoCanView',
    props: [ 'team' ],
    emits: [ 'close' ],
    data() {
        return {
            isLoaded: false,
            publicUsers: [] as any[],
            users: [] as any[],
            teamHubAdmins: [] as any[]
        }
    },
    computed: {
        isCompany(): boolean {
            return this.team == COMPANY_TEAM;
        }
    },
    async created() {
        if(this.isCompany) {
            this.isLoaded = true;
            return;
        }
        await axios.get(`${this.$store.state.apiUrl}/api/scoreboard/viewers`, { params: { team: this.team } })
            .then(resp => {
                this.publicUsers = resp.data.PublicUsers;
                this.users = resp.data.Users;
                this.teamHubAdmins = resp.data.TeamHubAdmins;
            })
            .catch(e => {
                console.log(e);
            })
        this.isLoaded = true;
    }
});
</script>
